'use es6';

import RequestStatusTypes from '../constants/RequestStatusTypes';
export var isUninitialized = function isUninitialized(requestStatus) {
  return requestStatus === RequestStatusTypes.UNINITIALIZED;
};
export var isPending = function isPending(requestStatus) {
  return requestStatus === RequestStatusTypes.PENDING;
};
export var isFailed = function isFailed(requestStatus) {
  return requestStatus === RequestStatusTypes.FAILED;
};